import { observable } from "mobx";
import { Type } from "class-transformer";
import DateRangeRequest from "./dateRangeRequest";
import SubLedgerReportChargeOrderRequest from "./subLedgerReportChargeOrderRequest";
import SubLedgerReportChargeRequest from "./subLedgerReportChargeRequest";
import SubLedgerReportPayGatePaymentRequest from "./subLedgerReportPayGatePaymentRequest";
import SubLedgerReportSummaryAccountingDocumentRequest from "./subLedgerReportSummaryAccountingDocumentRequest";
import SubLedgerReportTransferPaymentRequest from "./subLedgerReportTransferPaymentRequest";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class SubLedgerReportRequest {
  @observable
  @Type(() => DateRangeRequest)
  accountingDate?: DateRangeRequest;

  @observable
  @Type(() => DateRangeRequest)
  createdDate?: DateRangeRequest;

  @observable
  accountingPeriod?: string;

  @observable
  sequenceName?: string;

  @observable
  sequenceNumber?: number;

  @observable
  credit?: number;

  @observable
  debit?: number;

  @observable
  documentHeaderDescription?: string;

  @observable
  documentRowDescription?: string;

  @observable
  papAnalyticBreakdown?: string;

  @observable
  papTransaction?: string;

  @observable
  partnerBalance?: string;

  @observable
  syntheticAccount?: string;

  @observable
  analyticAccount?: string;

  @observable
  paragraph?: string;

  @observable
  article?: string;

  @observable
  @Type(() => SubLedgerReportSummaryAccountingDocumentRequest)
  summaryAccountingDocument?: SubLedgerReportSummaryAccountingDocumentRequest;

  @observable
  @Type(() => SubLedgerReportChargeOrderRequest)
  chargeOrder?: SubLedgerReportChargeOrderRequest;

  @observable
  @Type(() => SubLedgerReportChargeRequest)
  charge?: SubLedgerReportChargeRequest;

  @observable
  @Type(() => SubLedgerReportTransferPaymentRequest)
  transferPayment?: SubLedgerReportTransferPaymentRequest;

  @observable
  @Type(() => SubLedgerReportPayGatePaymentRequest)
  payGatePayment?: SubLedgerReportPayGatePaymentRequest;
}

export const SubLedgerReportRequestValidationRules: EntityValidationRules<SubLedgerReportRequest> = {
  createdDate: {
    isDateRange: {
      condition: (entity: DateRangeRequest) => !!entity.from && !!entity.to,
    },
  },

  accountingDate: {
    isDateRange: {
      condition: (entity: DateRangeRequest) => !!entity.from && !!entity.to,
    },
  },

  sequenceName: {
    isLength: {
      min: 3,
      max: 10,
    },
  },
  sequenceNumber: {
    isLength: {
      min: 3,
    },
  },
  documentHeaderDescription: {
    isLength: {
      min: 3,
      max: 50,
      optional: true,
    },
  },
  documentRowDescription: {
    isLength: {
      min: 3,
      max: 50,
      optional: true,
    },
  },
  papAnalyticBreakdown: {
    isLength: {
      min: 8,
      optional: true,
    },
  },
  papTransaction: {
    isLength: {
      max: 3,
      optional: true,
    },
  },
  partnerBalance: {
    isLength: {
      max: 10,
      optional: true,
    },
  },
  analyticAccount: {
    isLength: {
      max: 14,
      optional: true,
    },
  },
  syntheticAccount: {
    isLength: {
      max: 3,
      optional: true,
    },
  },
  paragraph: {
    isLength: {
      max: 4,
      optional: true,
    },
  },
  article: {
    isLength: {
      max: 4,
      optional: true,
    },
  },
};
